import Vue from 'vue'

import { validate, postLWACode, getOACode } from "@/api/oauth";
import { setToken } from "@/utils/storage"
import { ERR_SUCCESS, ERR_TO_AMAZON, ERR_TO_GRANT } from '@/const/consts';

export const VALIDATE = 'VALIDATE'; // 验证码校验
export const POSTLWACODE = 'POSTLWACODE'; // 

export default {
    state: {
        accessToken: "",
        // client_id: "",
        // response_type: "",
        // scope: "",
        // redirect_uri: "",
        // state: ""
    },

    getters: {

    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.accessToken = token
        },
    },

    actions: {
        [VALIDATE] ({commit}, data) {
            return new Promise(function(resolve, reject) {
                validate(data).then(resp => {
                    switch (resp.data.code) {
                        case ERR_TO_AMAZON:
                        case ERR_TO_GRANT:
                            //commit('SET_TOKEN', token)
                            setToken(resp.data.token)
                        default:
                            resolve(resp.data)
                            break;
                    }
                }).catch(err => {
                    console.error(err)
                    reject(err)
                })
            })
        },
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/store/modules/skillenable.js
// module id = null
// module chunks = 